/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Empty_TitleInputs */

const en_signin_empty_title = /** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sign-in method is set up`)
};

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const ar_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const he_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const ur_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const es_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const fr_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const de_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const pt_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const hi_signin_empty_title = en_signin_empty_title;

/** @type {(inputs: Signin_Empty_TitleInputs) => LocalizedString} */
const bn_signin_empty_title = en_signin_empty_title;

/**
* | output |
* | --- |
* | "No sign-in method is set up" |
*
* @param {Signin_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_empty_title = /** @type {((inputs?: Signin_Empty_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Empty_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_empty_title(inputs)
	if (locale === "he") return he_signin_empty_title(inputs)
	if (locale === "ur") return ur_signin_empty_title(inputs)
	if (locale === "es") return es_signin_empty_title(inputs)
	if (locale === "fr") return fr_signin_empty_title(inputs)
	if (locale === "de") return de_signin_empty_title(inputs)
	if (locale === "pt") return pt_signin_empty_title(inputs)
	if (locale === "hi") return hi_signin_empty_title(inputs)
	if (locale === "bn") return bn_signin_empty_title(inputs)
	return /** @type {LocalizedString} */ ("No sign-in method is set up")
});